import React from 'react';

// agents: buildAgentStats(calls) output — [{ key, name, totalCalls, answered, ... }],
// already sorted answered-desc. Plain CSS bars rather than SVG: a horizontal
// list of discrete rows has no continuous axis math to justify it, and
// flexbox gives responsive sizing for free.
function AgentComparisonChart({ agents }) {
  if (agents.length === 0) {
    return <p className="agent-page-empty">No agent-handled calls in this date range.</p>;
  }

  const maxTotal = Math.max(1, ...agents.map((agent) => agent.totalCalls));

  return (
    <div className="chart-card agent-comparison-card">
      <div className="trend-chart-header">
        <h3 className="heatmap-title">Agent Comparison</h3>
        <div className="trend-legend">
          <span className="trend-legend-item">
            <svg width="16" height="4" aria-hidden="true">
              <line x1="0" y1="2" x2="16" y2="2" stroke="var(--color-success)" strokeWidth="2" strokeLinecap="round" />
            </svg>
            Answered
          </span>
          <span className="trend-legend-item">
            <svg width="16" height="4" aria-hidden="true">
              <line x1="0" y1="2" x2="16" y2="2" stroke="var(--color-danger)" strokeWidth="2" strokeLinecap="round" />
            </svg>
            Not Answered
          </span>
        </div>
      </div>

      <div className="agent-comparison-list">
        {agents.map((agent) => {
          const notAnswered = agent.totalCalls - agent.answered;
          const answeredPct = (agent.answered / maxTotal) * 100;
          const notAnsweredPct = (notAnswered / maxTotal) * 100;
          const rate = agent.totalCalls > 0 ? Math.round((agent.answered / agent.totalCalls) * 100) : null;

          return (
            <div className="agent-comparison-row" key={agent.key}>
              <span className="agent-comparison-label" title={agent.name}>
                {agent.name}
              </span>
              <span className="agent-comparison-bar-track">
                <span className="agent-comparison-bar-fill answered" style={{ width: `${answeredPct}%` }} />
                <span className="agent-comparison-bar-fill missed" style={{ width: `${notAnsweredPct}%` }} />
              </span>
              <span className="agent-comparison-value">
                {agent.totalCalls} call{agent.totalCalls === 1 ? '' : 's'}
                {rate !== null ? ` · ${rate}%` : ''}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AgentComparisonChart;
